import React from 'react'
import styled from 'styled-components'
import ScrollView from '../ScrollView'

export type SidebarProps = {
  className?: string
}

const Sidebar = styled.div.attrs<SidebarProps>((props) => ({
  children: <ScrollView>{props.children}</ScrollView>
}))<SidebarProps>`
  background-color: #fff;
  width: 380px;
  box-shadow: 0 0 25px rgba(0, 0, 0, 0.15);
  margin-top: -55px;
  padding-top: 55px;
`

export default Sidebar
